export const defaultTheme = {
    name: "default",
    colors: {
        primary: "#27903F",
        primaryHover: "#218838",
        primaryActive: "#1e7835",
        secondary: "#009b4d",
        secondaryHover: "#008840",
        accent: "#10b981",
        accentHover: "#059669",
        background: "#f6f8fa",
        backgroundSecondary: "#f9fafb",
        backgroundTertiary: "#fff",
        surface: "#fff",
        surfaceHover: "#f9fafb",
        border: "#e5e7eb",
        borderHover: "#d1d5db",
        borderFocus: "#27903F",
        text: "#111827",
        textSecondary: "#374151",
        textTertiary: "#4E8F50",
        textDisabled: "#9ca3af",
        textOnPrimary: "#fff",
        textOnSecondary: "#fff",
        success: "#4E8F50",
        successBackground: "#ecfdf5",
        successBorder: "#6ee7b7",
        error: "#ef4444",
        errorBackground: "#fee2e2",
        errorBorder: "#fca5a5",
        warning: "#f59e0b",
        warningBackground: "#fef3c7",
        warningBorder: "#fcd34d",
        info: "#3b82f6",
        infoBackground: "#dbeafe",
        infoBorder: "#93c5fd",
    },
    typography: {
        fontFamily: "'Inter', system-ui, -apple-system, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif",
        fontFamilyHeading: "'Inter', system-ui, -apple-system, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif",
        fontSizeXs: "12px",
        fontSizeSm: "14px",
        fontSizeMd: "16px",
        fontSizeLg: "18px",
        fontSizeXl: "20px",
        fontSize2xl: "24px",
        fontSize3xl: "30px",
        fontWeightNormal: "400",
        fontWeightMedium: "500",
        fontWeightSemibold: "600",
        fontWeightBold: "700",
        lineHeightTight: "1.25",
        lineHeightNormal: "1.5",
        lineHeightRelaxed: "1.75",
    },
    spacing: {
        xs: "4px",
        sm: "8px",
        md: "12px",
        lg: "16px",
        xl: "20px",
        "2xl": "24px",
        "3xl": "32px",
        "4xl": "40px",
    },
    shadows: {
        none: "none",
        sm: "0 1px 2px 0 rgba(0, 0, 0, 0.05)",
        md: "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)",
        lg: "0 8px 24px rgba(16, 24, 40, 0.08)",
        xl: "0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)",
        "2xl": "0 25px 50px -12px rgba(0, 0, 0, 0.25)",
    },
    radii: {
        none: "0",
        sm: "4px",
        md: "8px",
        lg: "12px",
        xl: "16px",
        full: "9999px",
    },
    transitions: {
        fast: "150ms cubic-bezier(0.4, 0, 0.2, 1)",
        normal: "200ms cubic-bezier(0.4, 0, 0.2, 1)",
        slow: "300ms cubic-bezier(0.4, 0, 0.2, 1)",
    },
    breakpoints: {
        mobile: "320px",
        tablet: "768px",
        desktop: "1024px",
        wide: "1280px",
    },
};
export const modernTheme = {
    name: "modern",
    colors: {
        primary: "#1e3a5f",
        primaryHover: "#2c4a6f",
        primaryActive: "#152942",
        secondary: "#ff6b35",
        secondaryHover: "#ff5722",
        accent: "#3b82f6",
        accentHover: "#2563eb",
        background: "#fff",
        backgroundSecondary: "#f8fafc",
        backgroundTertiary: "#f1f5f9",
        surface: "#ffffff",
        surfaceHover: "#f8fafc",
        border: "#e2e8f0",
        borderHover: "#cbd5e1",
        borderFocus: "#3b82f6",
        text: "#1e293b",
        textSecondary: "#64748b",
        textTertiary: "#94a3b8",
        textDisabled: "#cbd5e1",
        textOnPrimary: "#ffffff",
        textOnSecondary: "#ffffff",
        success: "#4E8F50",
        successBackground: "#ecfdf5",
        successBorder: "#6ee7b7",
        error: "#ef4444",
        errorBackground: "#fef2f2",
        errorBorder: "#fca5a5",
        warning: "#f59e0b",
        warningBackground: "#fffbeb",
        warningBorder: "#fcd34d",
        info: "#0ea5e9",
        infoBackground: "#e0f2fe",
        infoBorder: "#7dd3fc",
    },
    typography: {
        fontFamily: "'Inter', system-ui, -apple-system, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif",
        fontFamilyHeading: "'Inter', system-ui, -apple-system, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif",
        fontSizeXs: "12px",
        fontSizeSm: "14px",
        fontSizeMd: "16px",
        fontSizeLg: "18px",
        fontSizeXl: "20px",
        fontSize2xl: "24px",
        fontSize3xl: "30px",
        fontWeightNormal: "400",
        fontWeightMedium: "500",
        fontWeightSemibold: "600",
        fontWeightBold: "700",
        lineHeightTight: "1.25",
        lineHeightNormal: "1.5",
        lineHeightRelaxed: "1.75",
    },
    spacing: {
        xs: "4px",
        sm: "8px",
        md: "12px",
        lg: "16px",
        xl: "20px",
        "2xl": "24px",
        "3xl": "32px",
        "4xl": "40px",
    },
    shadows: {
        none: "none",
        sm: "0 1px 2px 0 rgba(0, 0, 0, 0.05)",
        md: "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)",
        lg: "0 8px 24px rgba(30, 58, 95, 0.12)",
        xl: "0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)",
        "2xl": "0 25px 50px -12px rgba(0, 0, 0, 0.25)",
    },
    radii: {
        none: "0",
        sm: "4px",
        md: "8px",
        lg: "12px",
        xl: "16px",
        full: "9999px",
    },
    transitions: {
        fast: "150ms cubic-bezier(0.4, 0, 0.2, 1)",
        normal: "200ms cubic-bezier(0.4, 0, 0.2, 1)",
        slow: "300ms cubic-bezier(0.4, 0, 0.2, 1)",
    },
    breakpoints: {
        mobile: "320px",
        tablet: "768px",
        desktop: "1024px",
        wide: "1280px",
    },
};
export const themes = {
    default: defaultTheme,
    modern: modernTheme,
};
